import { useState, useCallback } from 'react';
import ErrorHelpers from '~/app/errorHelpers.js';

/**
 * useTVA
 *
 * Owns the Agent Assist state that was previously class state
 * on FormViewer:
 *
 *   runTVASend(blob, name, desc, type, isPDF) — submit image to Agent Assist
 *   openTVAHelp()                             — open Agent Assist help form
 *
 * State returned for render:
 *   isVisionModalOpen, TVAprogress, TVARetrieveCount
 *   openTVADisallow, TVAargType
 *   tvaObject, tvaID
 *
 * Callers must supply:
 *   calcAPIRef      — ref to CalcAPI instance
 *   formNavRef      — ref to formNav hook
 *   onShowErrorSnackbar — callback for error display
 */
const useTVA = ({ calcAPIRef, formNavRef, onShowErrorSnackbar }) => {
  const [isVisionModalOpen, setIsVisionModalOpen] = useState(false);
  const [TVAprogress, setTVAprogress] = useState(0);
  const [TVARetrieveCount, setTVARetrieveCount] = useState(0);
  const [openTVADisallow, setOpenTVADisallow] = useState(false);
  const [TVAargType, setTVAargType] = useState('');
  const [tvaObject, setTvaObject] = useState(null);
  const [tvaID, setTvaID] = useState(null);

  const runTVASend = useCallback(
    async (blob, imageName, imageDescription, imageType, isPDF) => {
      try {
        if (blob) {
          calcAPIRef.current?.TVASend(blob, imageName, imageDescription, imageType, isPDF);
        } else {
          throw new Error('Image Blob not attached, Unable to run Agent Assist');
        }
      } catch (err) {
        onShowErrorSnackbar(err.message);
        ErrorHelpers.handleError('Agent Assist: ', err);
      }
    },
    [calcAPIRef, onShowErrorSnackbar],
  );

  const openTVAHelp = useCallback(() => {
    calcAPIRef.current?.TVAHelp(formNavRef.current?.activeForm);
  }, [calcAPIRef, formNavRef]);

  return {
    isVisionModalOpen,
    setIsVisionModalOpen,
    TVAprogress,
    setTVAprogress,
    TVARetrieveCount,
    setTVARetrieveCount,
    openTVADisallow,
    setOpenTVADisallow,
    TVAargType,
    setTVAargType,
    tvaObject,
    setTvaObject,
    tvaID,
    setTvaID,
    runTVASend,
    openTVAHelp,
  };
};

export default useTVA;
